export const LOADING_MESSAGE = '请稍等...';
export const CERTIFICATE_SUCCESS = 'CERTIFICATE_SUCCESS';
export const ID_CHECK_AND_SAVE_SUCCESS = 'ID_CHECK_AND_SAVE_SUCCESS';
export const ID_REFUSE_SUCCESS = 'ID_REFUSE_SUCCESS';
export const ID_RECALL_SUCCESS = 'ID_RECALL_SUCCESS';
export const IDENTIFICATION_CONFIG_SUCCESS = 'IDENTIFICATION_CONFIG_SUCCESS';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
